<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'siteregistrations.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="SiteFormsGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="SiteFormsGrid" name="SiteFormsGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'SiteFormsGrid',
  components: {
    Grid
  },
  data() {
    return {
      filters: {
        dsr: null,
        dsr_id: null
      },
      gridFilters: [{
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dsr/lst/dsr',
        field: 'dsr_id'
      }, {
        api: 'dsr/lst/dsr',
        field: 'change_dsr_id'
      }],
      url: 'siteregistrations',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'dsr_id',
        title: 'Criado por',
        width: '220px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '120px',
        values: lists.formStates
      },
      {
        field: 'alteration_type',
        title: 'Tipo Alteração',
        width: '120px',
        values: lists.formAlterationTypes
      },
      {
        field: 'change_dsr_id',
        title: 'DSR a mudar',
        width: '120px'
      },
      {
        field: 'dsr_type',
        title: 'Tipo DSR',
        width: '120px',
        values: lists.dsrTypes
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'first_name',
        title: 'Nome',
        width: '120px'
      },
      {
        field: 'last_name',
        title: 'Apelido',
        width: '120px'
      },
      {
        field: 'phone',
        title: 'Telefone',
        width: '120px'
      },
      {
        field: 'email',
        title: 'Email',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    selectDsr(e) {
      if(e.item) {
        this.filters.dsr_id = e.item.id
        this.filters.dsr = e.item
        this.$refs.SiteFormsGrid.applyFilter('dsr_id', this.filters.dsr_id)
      } else {
        this.filters.dsr_id = null
        this.filters.dsr = null
        this.$refs.SiteFormsGrid.removeFilter('dsr_id')
      }
    },
    selectZone(e) {
      if(e.item) {
        this.filters.zone_id = e.item.id
        this.filters.zone = e.item
        this.$refs.SiteFormsGrid.applyFilter('zone', this.filters.zone.zone)
      } else {
        this.filters.zone_id = null
        this.filters.zone = null
        this.$refs.SiteFormsGrid.removeFilter('zone')
      }
    },
    selectBestof(e) {
      if(e.item) {
        this.filters.campaign_id = e.item.id
        this.filters.campaign = e.item
        this.$refs.SiteFormsGrid.applyFilter('campaign_id', this.filters.campaign_id)
      } else {
        this.filters.campaign_id = null
        this.filters.campaign = null
        this.$refs.SiteFormsGrid.removeFilter('campaign_id')
      }
    },
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'siteregistrations.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('siteregistrations.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
